import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import CenteredLoading from './components/CenteredLoading';
const Administrators = lazy(() => import('./pages/Administrators/Administrators'));
const AdministratorDetails = lazy(() => import('./pages/Administrators/AdministratorDetails/AdministratorDetails'));
const AddAdministrator = lazy(() => import('./pages/Administrators/AddAdministrator/AddAdministrator'));
const Assessments = lazy(() => import('./pages/Assessments/Assessments'));
const AssessmentDetails = lazy(() => import('./pages/Assessments/AssessmentDetails/AssessmentDetails'));
// const Attendance = lazy(() => import('./pages/Attendance/Attendance'));
const Classes = lazy(() => import('./pages/Classes/Classes'));
const ResetPassword = lazy(() => import('./pages/Login/ResetPassword'));
const ClassDetails = lazy(() => import('./pages/Classes/ClassDetails/ClassDetails'));
const ClassGrowthCards = lazy(() => import('./pages/Classes/ClassDetails/GrowthCards/ClassGrowthCards'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const GrowthCards = lazy(() => import('./pages/Students/StudentDetails/GrowthCards/GrowthCards'));
const Instructors = lazy(() => import('./pages/Instructors/Instructors'));
const InstructorDetails = lazy(() => import('./pages/Instructors/InstructorDetails/InstructorDetails'));
const Login = lazy(() => import('./pages/Login/Login'));
const Reports = lazy(() => import('./pages/Reports/Reports'));
const RubricDetails = lazy(() => import('./pages/Assessments/RubricDetails/RubricDetails'));
// const Settings = lazy(() => import('./pages/Settings/Settings'));
const Students = lazy(() => import('./pages/Students/Students'));
const StudentDetails = lazy(() => import('./pages/Students/StudentDetails/StudentDetails'));
const UserProfile = lazy(() => import('./pages/UserProfile/UserProfile'));

const routes = (
  <BrowserRouter>
    <Suspense fallback={<CenteredLoading />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword type="reset" />} />
        <Route path="/welcome" element={<ResetPassword type="welcome" />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/instructors">
            <Route index element={<Instructors />} />
            <Route path=":instructorId" element={<InstructorDetails />} />
          </Route>
          <Route path="/students">
            <Route index element={<Students />} />
            <Route path=":studentId">
              <Route index element={<StudentDetails />} />
              <Route path="growth-cards">
                <Route index element={<Navigate to=".." />} />
                <Route path=":classId" element={<GrowthCards />} />
              </Route>
            </Route>
          </Route>
          <Route path="/administrators">
            <Route index element={<Administrators />} />
            <Route path="new" element={<AddAdministrator />} />
            <Route path=":administratorId">
              <Route index element={<AdministratorDetails />} />
            </Route>
          </Route>
          <Route path="/classes">
            <Route index element={<Classes />} />
            <Route path=":classId">
              <Route index element={<ClassDetails />} />
              <Route path="growth-cards" element={<ClassGrowthCards />} />
            </Route>
          </Route>
          {/* <Route path="/attendance" element={<Attendance />} /> */}
          <Route path="/reports" element={<Reports />} />
          <Route path="/assessments">
            <Route index element={<Assessments />} />
            <Route path=":assessmentId">
              <Route index element={<AssessmentDetails />} />
              <Route path="rubric" element={<RubricDetails />} />
            </Route>
          </Route>
          {/* <Route path="/settings" element={<Settings />} /> */}
        </Route>
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default routes;